import React from "react";
import ReportingChart from "../Reporting/ReportingChart";
import _ from "lodash";
import gql from "graphql-tag";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

const ECRITURELINE_CREATED_SUBSCRIPTION = gql`
  subscription onEcritureLineCreated($companyId: ID!) {
    ecritureLineCreated(companyId: $companyId) {
      id
      journal
      amount
      libelle
      libelleExport
      dateOperation
      dateLettrage
      labelLettrage
      tiersClient {
        id
      }
      project {
        id
        tiersClient {
          id
        }
      }
      article {
        id
      }
      category {
        id
      }
    }
  }
`;

const ECRITURELINE_UPDATED_SUBSCRIPTION = gql`
  subscription onEcritureLineUpdated($companyId: ID!) {
    ecritureLineUpdated(companyId: $companyId) {
      id
      journal
      amount
      libelle
      libelleExport
      dateOperation
      dateLettrage
      labelLettrage
      tiersClient {
        id
      }
      project {
        id
        tiersClient {
          id
        }
      }
      article {
        id
      }
      category {
        id
      }
    }
  }
`;

const ECRITURELINE_DELETED_SUBSCRIPTION = gql`
  subscription onEcritureLineDeleted($companyId: ID!) {
    ecritureLineDeleted(companyId: $companyId) {
      id
      journal
      amount
      libelle
      libelleExport
      dateOperation
      dateLettrage
      labelLettrage
      tiersClient {
        id
      }
      project {
        id
        tiersClient {
          id
        }
      }
      article {
        id
      }
      category {
        id
      }
    }
  }
`;

const LETTRAGE_DONE = gql`
  subscription onEcritureLineLettrageDone($companyId: ID!) {
    ecritureLineLettrageDone(companyId: $companyId) {
      date
    }
  }
`;

class SalesChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.startCursorArray = [];
  }
  componentDidUpdate() {
    const data =
      this.props.data && this.props.data.ecritureLinesConnectionForSales;

    if (!!!data) {
      this.startCursorArray = [];
      return;
    }

    const pageInfo = data && data.pageInfo;

    const startCursor = pageInfo && pageInfo.startCursor;
    if (this.startCursorArray.includes(startCursor)) {
      console.log("125 - already in array:", startCursor);
      return;
    }
    this.startCursorArray.push(startCursor);

    if (pageInfo.hasNextPage) {
      this.props.onLoadMore(
        pageInfo.endCursor,
        "ecritureLinesConnectionForSales"
      );
    }
  }

  componentDidMount() {
    // console.log("104 - RentabilityChart.componentDidMount", this);
    this.startCursorArray = [];
    if (!this.props.data) return;

    // this.startCursorArray = [];

    // ecritureLineCreated
    this.unsubscribeEcritureLineCreated = this.props.subscribeToMore({
      document: ECRITURELINE_CREATED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        this.startCursorArray = [];
        this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });

    // ecritureLineUpdated
    this.unsubscribeEcritureLineUpdated = this.props.subscribeToMore({
      document: ECRITURELINE_UPDATED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        //this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });

    // ecritureLineDeleted
    this.unsubscribeEcritureLineDeleted = this.props.subscribeToMore({
      document: ECRITURELINE_DELETED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        this.startCursorArray = [];
        this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });

    // lettageDoneCreated
    this.unsubscribeLettageDone = this.props.subscribeToMore({
      document: LETTRAGE_DONE,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        this.startCursorArray = [];
        this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });
    return;
  }

  componentWillUnmount() {
    this.unsubscribeEcritureLineCreated();
    this.unsubscribeEcritureLineUpdated();
    this.unsubscribeEcritureLineDeleted();
    this.unsubscribeLettageDone();
  }

  static getDerivedStateFromProps = async (props, state) => {
    //console.log("getDerivedStateFromProps", props);

    if (props && props.data && props.data.ecritureLinesConnectionForSales) {
      state.data = props.data;

      let edges =
        state &&
        state.data &&
        state.data.ecritureLinesConnectionForSales &&
        state.data.ecritureLinesConnectionForSales.edges;

      if (edges) {
        edges = _.orderBy(
          edges,
          [
            "node.tiers.name",
            "node.tiers.tiersClient.name",
            "node.category.categoryFamily.name",
            "node.category.name",
            "node.project.name",
            "node.article.name"
          ],
          ["asc", "asc", "asc", "asc", "asc", "asc"]
        );
        state.data.ecritureLinesConnectionForSales.edges = edges;

        // console.log("coucou sorted", edges);
        // // TRANSLATIONS.....

        _.forEach(edges, o => {
          if (o.node && o.node.category && o.node.category.ids !== null) {
            // console.log("=>", o.node.category.ids);
            o.node.category.name = props.intl.formatMessage({
              id: o.node.category.ids
            });
          }

          if (
            o.node &&
            o.node.category &&
            o.node.category &&
            o.node.category.categoryFamily &&
            o.node.category.categoryFamily.ids !== null
          ) {
            o.node.category.categoryFamily.name = props.intl.formatMessage({
              id: o.node.category.categoryFamily.ids
            });
          }

          if (o.node && o.node.tiersClient && o.node.tiersClient.id === "FAKE_ID_CLIENT") {
            o.node.tiersClient.name = props.intl.formatMessage({
              id: o.node.tiersClient.name
            });
          }
          if (o.node && o.node.project && o.node.project.id === "FAKE_ID_PROJECT") {
            o.node.project.name = props.intl.formatMessage({
              id: o.node.project.name
            });
          }

          // console.log("285 - o.article.id=", o.node && o.node.article && o.node.article.id);
          // console.log("o.node=", o.node);
          if (o.node && o.node.invoice && o.node.invoice.invoiceLines && o.node.article && o.node.article.id) {

            let articleQty = 0;
            _.forEach(o.node.invoice.invoiceLines, invoiceLine => {
              if (
                invoiceLine && invoiceLine.article && invoiceLine.article.id &&
                invoiceLine.article.id === o.node.article.id && parseFloat(invoiceLine.prixTotalHTApresRemise).toFixed(2) == -parseFloat(o.node.amount).toFixed(2)
              )
                articleQty = articleQty + invoiceLine.quantity;
            });
            //console.log("285 - article=", o.node.article.name, articleQty);
            // o.node.article.quantity = articleQty;
            o.node.qty = articleQty;
          }
        });
      }
    }
  };

  render() {
    console.log("SalesChart render", this.props);

    const data =
      this.state.data && this.state.data.ecritureLinesConnectionForSales;

    const edges = data && this.state.data.ecritureLinesConnectionForSales.edges;

    return (
      <div>
        <ReportingChart
          {...this.props}
          edges={edges}
          negateValues={true}
          type="sales"
          tabs={["tiersAsClient", "project", "product", "seller", "quantity"]}
          onRowClick={(row, state, rowInfo, column, instance) => {
            if (rowInfo.original.invoice)
              this.props.history.push(
                `/invoices/${rowInfo.original.invoice.id}/view`
              );
            else if (rowInfo.original.bankTransaction)
              this.props.history.push(
                `/payments/${rowInfo.original.bankTransaction.id}/affectation`
              );
          }}
        />
      </div>
    );
  }
}

export default withRouter(injectIntl(SalesChart));
